import React, { useState } from "react";

import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

const BadgesEllipsis = ({ objItems }) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  return (
    <React.Fragment>
      <div>
        {objItems.length > 2 ? (
          <div className="d-flex">
            {objItems.slice(0, 2).map((item, key) => (
              <div key={key} className="overflow-auto d-inline-flex">
                <span className="badge-ellipsis font-size-12 mr-2 badge badge-success">
                  {item.name}
                </span>
              </div>
            ))}
            <Dropdown
              className="d-inline-flex"
              // onClick={() => toggleModal()}
              onMouseEnter={() => toggleModal()}
              onMouseLeave={() => toggleModal()}
              isOpen={modal}
              nav={false}
              a11y={false}
            >
              <div className="d-inline-flex overflow-auto">
                <DropdownToggle
                  tag="span"
                  className="badge-ellipsis font-size-12 mr-2 badge badge-success align-self-center"
                >
                  +{objItems.length - 2}
                </DropdownToggle>
              </div>
              <DropdownMenu>
                {objItems.slice(2, objItems.length).map((item, key) => (
                  <div key={key} className="overflow-auto d-flex">
                    <span className="badge-ellipsis font-size-12 mx-2 my-1 badge badge-success">
                      {item.name}
                    </span>
                  </div>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        ) : (
          <div className="d-flex">
            {objItems.map((item, key) => (
              <div key={key} className="overflow-auto d-inline-flex">
                <span className="badge-ellipsis font-size-12 mr-2 badge badge-success">
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default BadgesEllipsis;
